export default __webpack_public_path__ + "static/media/closed-space.a35a4f8c.png";